import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { routerActions } from 'react-router-redux'

import LeftNav from 'material-ui/Drawer'
import {getByType} from 'utils/stuff'
import Header from 'components/Header'
import Hamburger from 'components/Hamburger'
import AddButton from 'components/AddButton'

import LeftNavMenu from 'components/LeftNavMenu'
import RightPanel from 'components/RightPanel/'
import ActionBar from 'components/ListLayoutParts/ActionBar'

import mobileActions from 'actions/mobile'
import actionBarActions from 'actions/actionbar'
import repairmenFiltersActions from 'actions/repairmenFilters'
import rightStackActions from 'actions/rightStackActions'
import yelpActions from 'actions/yelp'
import dataActions from 'actions/dataActions'
import Error from 'components/Error'
import loginActions from 'actions/login'
import PopupNotification from 'components/ListLayoutParts/PopupNotification'

let select = state => state
export class ListLayout extends Component {
	constructor(props){
		super(props)
		this.state={
			showOmni: false
		}
	}
	componentDidMount(){
		//I will burn in hel for this
		//It's because the default state is mutating initial
		setTimeout(()=> {
			this.props.TOOGLE_LEFT_NAV()
			this.props.TOOGLE_LEFT_NAV()
		}, 1500)
	}
	componentWillUpdate(props, nextProp){
		if(props.routes[3].path != this.props.routes[3].path){
			if(this.props.actionBarReducers.leftNav) this.props.CLOSE_LEFT_NAV()
		}
	}
	render(){
		let type, categoryText, renderElement, newProject
		if(this.props.routes
			&& this.props.routes[3]
		){
			renderElement = this.props.routes[3].renderEl || undefined
			categoryText = this.props.routes[3].categoryText || undefined
			type = this.props.routes[3].type || undefined
			newProject = this.props.routes[3].newProject || undefined
		}
		let pageID = (newProject)? "NewProject" : this.props.params.id
		return(
		  	<div className='page-container layout'>
					<PopupNotification />
					<div style={{position:"fixed", width:"60px", top:"60px", zIndex:"999999"}} >
						<LeftNavMenu route={this.props.route} />
					</div>
					<Header style={{width: "100%", height: "60px"}}>
						<Hamburger />
						<ActionBar
							navPanelIsOpened={this.props.actionBarReducers.leftNav}
							rightStackOpened={!!(renderElement && pageID)}
							filtersIsOpened={this.props.actionBarReducers.rightNav}
							handleToggleLeft={this.props.TOOGLE_LEFT_NAV}
							handleToggleFilters={this.props.TOOGLE_FILTERS_PANEL}
							showOmni={() => this.setState({showOmni: true})}
							hideOmni={() => this.setState({showOmni: false})}
							showOmnibox={this.state.showOmni}
							addEnt={this.props.routes[3].addFunc}
							addEntFunc={() => {
								this.props.routes[3].addFunc({
									history: this.props.history
								  , docUPD: this.props.DOC_UPDATE
								  , NEW: this.props.NEW
									, go: this.props.push
								})
							}}
							addEntAltFunc={(this.props.routes[3].addFuncAlt)?
								() => {
									this.props.routes[3].addFuncAlt({
										history: this.props.history
									  , docUPD: this.props.DOC_UPDATE
									  , NEW: this.props.NEW
									})
								}
								: undefined
							}
							categoryText={categoryText}
							addEntText={this.props.routes[3].addText}
							addEntTextAlt={this.props.routes[3].addTextAlt}
						/>
					</Header>
					<div className='view-container layout' style={{height: 'calc(100vh-60px)', overflow: 'hidden'}}>
						<div
							style={{
								marginLeft: (typeof global.global.md.phone() == 'string' && this.props.actionBarReducers.leftNav)?
									"85%"
									: "0"
							  , width: (typeof global.md.phone() == 'string' && this.props.actionBarReducers.leftNav)?
								  "100%"
								  : "auto"
							}}
						>
							<div className="flex-box" style={{width:"100%"}}>
								<div
									style={{
										marginTop: "-60px"
									}}
								>
			  						{this.props.children}
								</div>
								{<div className="stack-right-panels" style={{
									width: (!this.props.routeParams.id)? '0': '630px'
								  , height: 'calc(100vh-60px)'
								}}>
									<LeftNav
										open={!!renderElement}
										openSecondary={true}
										containerStyle={{zIndex: 1000, overflow: 'hidden'}}
										width={(!!renderElement)? "47%": 0}
										className="right-tab"
									>
										{(renderElement && pageID)?
											renderElement({
												rightPanel : true
											  , style : {
												  height: "100vh"//(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "100vh" : "calc(100vh - 108px)"
												  , overflowY: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "auto" : 'hidden'
												}
											  , refTask : (this.props.routing.state && this.props.routing.state.refTask)?this.props.routing.state.refTask: undefined
											  , refRepMan : (this.props.routing.state && this.props.routing.state.refRepMan)?this.props.routing.state.refRepMan: undefined
											  , refAgent : (this.props.routing.state && this.props.routing.state.refAgent)?this.props.routing.state.refAgent: undefined
											  , id : pageID
											  , history: this.props.history
											})

											: <div></div>
										}
									</LeftNav>

								</div>}
							</div>
						</div>
		  		</div>
		  	</div>
		)
	}
}

export default connect(select, R.mergeAll([actionBarActions, routerActions, repairmenFiltersActions, mobileActions, loginActions, rightStackActions, dataActions]))(ListLayout)



// WEBPACK FOOTER //
// ./src/components/layouts/ListLayout.js